var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"box text-center  on-top"},[_c('b',{},[_vm._v(_vm._s(_vm._f("translate")('title.urlForm')))])]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }